<template>
  <div class="reservationPanelMobileHeader">
    <div class="reservationPanelMobileHeader__Top">
      <button type="button" @click="emit('stepBack')">
        <img src="/resources/images/icons/back.svg" width="24" height="24" />
      </button>
      <button type="button" @click="emit('close')">
        <img src="/resources/images/icons/close.svg" width="24" height="24" />
      </button>
    </div>
    <slot />
  </div>
</template>

<script setup>
  const emit = defineEmits(['close', 'stepBack']);
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_reservationPanelMobileHeader.scss');
</style>